import React, { useState } from 'react';
import styled from 'styled-components';
import { MaskRange } from '../../facades/MaskedInput';
import { MaskedInput } from '../../facades';

export interface AsureCloudDateInput
  extends React.InputHTMLAttributes<HTMLInputElement> {
  invalidDateMessage?: string;
  onUpdate: any;
  label?: string;
  fromYear?: number;
  toYear?: number;
}

export const AsureCloudDateInput = ({
  invalidDateMessage,
  onUpdate,
  label,
  fromYear,
  toYear,
  ...props
}: AsureCloudDateInput) => {
  const [isInvalid, setInvalid] = useState(false);
  const [maskedRef, setMaskedRef] = useState<HTMLInputElement>();

  const isLeapYear = (year) => {
    return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
  };
  const onInputUpdate = (mask) => {
    setMaskedRef(mask.el.input);
    const dateArray = mask.value.split('/');
    const month = dateArray[0] || undefined;
    let day = dateArray[1] || undefined;
    const year = dateArray[2] || undefined;
    const thirtyOneMonths = ['01', '03', '05', '07', '08', '10', '12'];
    const leapYear = isLeapYear(year);
    let isDirty = false;

    if (thirtyOneMonths.indexOf(month) === -1 && day === '31') {
      day = 30;
      isDirty = true;
    }
    if (year?.length === 4 && month === '02' && day > 28) {
      if (leapYear && day >= 29) {
        day = 29;
        isDirty = true;
      } else {
        day = 28;
        isDirty = true;
      }
    }

    if (isDirty) {
      mask.value = [month, day, year].filter(Boolean).join('/');
    }
    onUpdate(mask.value);
  };
  const onBlur = (event) => {
    event.stopPropagation();
    if (event.target.value.length !== 10) {
      maskedRef.setCustomValidity(invalidDateMessage);
      setInvalid(true);
    }
  };
  const clearInvalid = () => {
    if (maskedRef !== undefined) {
      maskedRef.setCustomValidity('');
    }
    isInvalid && setInvalid(false);
  };
  return (
    <div className="d-flex flex-column-reverse">
      <MaskedInput
        {...props}
        mask={Date}
        pattern="m/`d/`Y"
        placeholder="mm/dd/yyyy"
        autofix={true}
        unmask={false}
        overwrite={true}
        className={`${props.className ? props.className : ''}${isInvalid ? ' invalid' : ''} p-2`}
        blocks={{
          d: {
            mask: MaskRange,
            from: 1,
            to: 31,
            maxLength: 2,
          },
          m: {
            mask: MaskRange,
            from: 1,
            to: 12,
            maxLength: 2,
          },
          Y: {
            mask: MaskRange,
            from: fromYear,
            to: toYear,
          },
        }}
        format={function (date) {
          var day = date.getDate();
          var month = date.getMonth() + 1;
          var year = date.getFullYear();

          if (day < 10) day = '0' + day;
          if (month < 10) month = '0' + month;
          let returnDate = [month, day, year].join('/');
          return returnDate;
        }}
        parse={function (str) {
          return new Date(str);
        }}
        onAccept={(value, mask) => onInputUpdate(mask)}
        onBlur={onBlur}
        onInvalidCapture={() => setInvalid(true)}
        onInput={clearInvalid} // defaults to `false`
      />
      <label className="mb-2 d-flex flex-row flex-nowrap">{label}</label>
    </div>
  );
};

export default AsureCloudDateInput;

AsureCloudDateInput.defaultProps = {
  invalidDateMessage: `Invalid date. Please check the date and reenter.`,
  fromYear: 1900,
  toYear: 9999,
};
